import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/per-10-gram";

export const Route = createFileRoute("/pakistan/per-10-gram")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `10 Gram Gold Price in Pakistan Today — Live 24K, 22K, 21K, 18K Per 10g Rate`;
    const description = `Aaj Pakistan mein 10 gram sone ka rate live — bullion trading standard weight for 24K, 22K, 21K, 18K across every major sarafa bazaar. 10 gram sona ka bhao, refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "unit", unit: "per-10-gram" }}
      h1="Gold Rate Per 10 Gram in Pakistan Today — Live"
      intro="Aaj Pakistan mein 10 gram sone ka rate — bullion aur investment ke liye standard weight. Har karat, har major sarafa bazaar ka live rate, refreshed every 10 minutes from international spot + USD/PKR."
    />
  ),
});